/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react';
import { SetConnectionChangeDataImplementationNotAvailable } from './errors';
const ConnectionChangeContext = createContext({
    error: undefined,
    hasConnectionChangeError: false,
    setConnectionChangeData(value) {
        throw new SetConnectionChangeDataImplementationNotAvailable(value);
    },
    // Safe no-ops outside a provider: request batching is a best-effort
    // optimization, not a hard requirement like setConnectionChangeData.
    registerRequestStart() { },
    registerRequestEnd() { }
});
export default ConnectionChangeContext;
